import InputAdornment from '@material-ui/core/InputAdornment';
import { useTheme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import SaveIcon from '@material-ui/icons/Save';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
// import { updateVodResource } from 'utils/apiCalls';
import { updateVodResourceAction } from 'store/conference/conferenceActions';

VodTrim.propTypes = {
  vodTime: PropTypes.number,
  sessionId: PropTypes.string.isRequired,
  videoUrl: PropTypes.string.isRequired,
  isMax: PropTypes.bool,
};

VodTrim.defaultProps = {
  vodTime: 0,
};

export default function VodTrim({ vodTime, sessionId, videoUrl, isMax }) {
  const [updatedTrim, setUpdatedTrim] = useState(vodTime);
  const [saving, setSaving] = useState(false);
  const theme = useTheme();
  const dispatch = useDispatch();

  const handleSave = async () => {
    if (updatedTrim !== vodTime) {
      setSaving(true);
      dispatch(
        updateVodResourceAction({
          VideoUrl: videoUrl,
          SessionId: sessionId,
          StartTime: isMax ? null : parseInt(updatedTrim),
          EndTime: isMax ? parseInt(updatedTrim) : null,
        })
      );
    }
  };
  const updateTrim = (time) => {
    try {
      setUpdatedTrim(parseInt(time));
    } catch (e) {
      setUpdatedTrim(time);
      console.log(`Unable To parseInt(${time})`);
    }
  };

  useEffect(() => {
    setSaving(false);
    updateTrim(vodTime);
  }, [vodTime]);

  return (
    <TextField
      label={isMax ? 'End' : 'Start'}
      type="number"
      min={0}
      onChange={(e) => updateTrim(e.target.value)}
      value={updatedTrim}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {saving ? (
              <CircularProgress size={20} color="primary" />
            ) : (
              <SaveIcon
                onClick={handleSave}
                style={{
                  color: updatedTrim !== vodTime ? theme.palette.primary.main : 'grey',
                  cursor: updatedTrim !== vodTime ? 'pointer' : 'auto',
                }}
              />
            )}
          </InputAdornment>
        ),
      }}
    />
  );
}
